/* eslint-disable import/prefer-default-export */
export const ROUTING_CLI_RECOMMEND_MESSAGE = '라우팅 테이블 수가 수집범위를 초과하여, CLI수집을 권고합니다';

export const faultCheckItemDefine = {
  DEVICE: 'DEVICE',
  INTERFACE: 'INTERFACE',
  CONFIG: 'CONFIG',
  HARDWARE: 'HARDWARE',
  ROUTING: 'ROUTING',
  VLAN: 'VLAN',
  STP: 'STP',
  IP: 'IP',
};



// WEBPACK FOOTER //
// ./src/constants/netdevice.js